import { ApiListBoardFeatureFlagsResponse, ApiListFeatureFlagsResponse } from '../../../api/core/models';
import { ClientFeatureFlag } from '../../../model/client-model/client-feature-flag';
import { BoardAndTenantClientFeatureFlags } from '../../backend/backend-feature-flags.service';

export function apiFeatureFlagsToClientFeatureFlags({
  featureFlags,
}: ApiListFeatureFlagsResponse): ClientFeatureFlag[] {
  return <ClientFeatureFlag[]>featureFlags.map(({ id, name, status }) => ({ id, name, status }));
}

export function apiBoardFeatureFlagsToBoardAndTenantClientFeatureFlags({
  boardFeatureFlags,
  tenantFeatureFlags,
}: ApiListBoardFeatureFlagsResponse): BoardAndTenantClientFeatureFlags {
  return <BoardAndTenantClientFeatureFlags>{
    boardFeatureFlags: boardFeatureFlags.map(({ id, name, status }) => ({ id, name, status })),
    tenantFeatureFlags: tenantFeatureFlags.map(({ id, name, status }) => ({ id, name, status })),
  };
}
